module.exports = __webpack_public_path__ + "img/r-67.3d037800.jpg";